import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import BarChart from './chart/BarChart';
import DoughnutChart from './chart/DoughnutChart';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import PieChart from './chart/PieChart';
import LineChart from './chart/LineChart';
import { useEffect, useState } from 'react';
import { requester } from 'App';
import DynamicTable from './top5/DynamicTable';
import Container from 'layouts/container/Container';
import Center from 'layouts/wrapper/Center';
import SettlementStatus from './settlementComp/SettlementStatus';

function VendorSalesStatistics() {
    const [products, setProducts] = useState();
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            requester.getBestSalesTop5(result => {
                setProducts(result.data);
            });
        }
    }, [isMounted]);
    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={50}>
                    <FlexChild width={"90%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P weight={'bold'} size={40}>
                                전체매출통계
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={'90%'}>
                        <SettlementStatus />
                    </FlexChild>
                    <FlexChild width={'90%'} backgroundColor={"white"} padding={"15px"}>

                        <VerticalFlex>
                            <FlexChild>
                                <P size={24} weight={'bold'}>
                                    상품별 판매량
                                </P>
                            </FlexChild>
                            <FlexChild>
                                <BarChart productData={products && products} />
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                    <FlexChild>
                        <P weight={'bold'} size={40}>
                            판매량 순위 TOP 5
                        </P>
                    </FlexChild>
                    <FlexChild width={'90%'}>
                        <div style={{ width: '100%' }}>
                            <DynamicTable fetchedData={products && products} />
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default VendorSalesStatistics;
